import type { AccountKey } from 'owa-client-types';
import { bizchatSidepaneStore } from '../store/store';
import type { BizchatSidepaneEnabledSettings } from '../store/store';

export function getBizchatAcquisitionSettings(
    accountKey: AccountKey
): BizchatSidepaneEnabledSettings | undefined {
    return bizchatSidepaneStore().hasBizchatAcquisitionMap.get(accountKey);
}
